import pushGTMEvent from '../../util/helper/pushGTMEvent';
import { chatDetails } from '../../App/App.config';

const configContents = ({ state: { langStrings, errorType } }) =>
  ({
    generalError: [
      {
        isTitle: true,
        hasErrorMark: true,
        description: langStrings
          ? langStrings.requestFailedScreen.pageTitle2
          : "Request can't be completed",
        id: 'adsk-page-title',
      },
      {
        description: langStrings
          ? langStrings.requestFailedScreen.contactOptionsBelow
          : 'If you need help, <a id="go-to-contact-us" href="javascript:void(0);">contact us</a> using an option below.',
        paragraphStyle: { marginBottom: '20px' },
        handleTextClick: () => {
          // expand Footer.
          document.querySelector('#adsktm-have-question-button').click()
        },
      },
    ],
    generalError2: [
      {
        isTitle: true,
        hasErrorMark: true,
        description: langStrings
          ? langStrings.requestFailedScreen.pageTitle2
          : "Request can't be completed",
        id: 'adsk-page-title',
      },
      {
        description: langStrings
          ? langStrings.requestFailedScreen.responseText
          : 'Sorry, something went wrong while processing your request.',
        paragraphStyle: { marginBottom: '20px' },
      },
      {
        isButton: true,
        id: 'adsk-submit-again',
        buttonTitle: langStrings
          ? langStrings.buttons.submitAgainButton
          : 'SUBMIT AGAIN',
        secondButtonId: 'adsk-contact-support',  
        handleButtonClick: () => {},
        secondButtonTitle: langStrings
          ? langStrings.buttons.contactSupportButton
          : '<a href="" class="adsktm-show-contact-support-btn">CONTACT SUPPORT</a>',
        handleSecondButtonClick: () => {
          pushGTMEvent('ContactSupport');
          // expand Footer. 
          document.querySelector('#adsktm-have-question-button').click()
        },
      },
    ],
    HL04: [
      {
        isTitle: true,
        hasErrorMark: true,
        description: langStrings
          ? langStrings.requestFailedScreen.inactiveSubsTitle
          : "Inactive subscription",
        id: 'adsk-page-title',
      },
      {
        description: langStrings
          ? langStrings.requestFailedScreen.noActiveSubs
          : `Your request can’t be completed because your subscription is not yet active or has expired. Please check with your account administrator	 or check your <a target="_blank" href="https://manage.autodesk.com/cep/#products-services">account</a> for renewal options.`,
        paragraphStyle: { marginBottom: '20px' },
      },
      {
        description: langStrings
          ? langStrings.requestFailedScreen.contactOptionsBelow
          : 'If you need help, <a id="go-to-contact-us" href="javascript:void(0);">contact us</a> using an option below.',
        paragraphStyle: { marginBottom: '20px' },
        handleTextClick: () => {
          // expand Footer.
          document.querySelector('#adsktm-have-question-button').click()
        },
      },
    ],
    HL06: [
      {
        isTitle: true,
        hasErrorMark: true,
        description: langStrings
          ? langStrings.requestFailedScreen.prodNotEligibleTitle
          : "Product not eligible",
        id: 'adsk-page-title',
      },
      {
        description: langStrings
          ? langStrings.hula.requestFailedScreen.hulaIneligible
          : "Your request can’t be completed because your product isn’t eligible for a home use license.",
        paragraphStyle: { marginBottom: '20px' },
      },
      {
        description: langStrings
          ? langStrings.hula.requestFailedScreen.hulaEligibilityReqs
          : '<a target="_blank" href="https://www.autodesk.com/eligible-home-use-products-eng">See eligibility requirements</a>',
        paragraphStyle: { marginBottom: '20px' },
      },
      {
        description: langStrings
          ? langStrings.requestFailedScreen.contactOptionsBelow
          : 'If you need help, <a id="go-to-contact-us" href="javascript:void(0);">contact us</a> using an option below.',
        paragraphStyle: { marginBottom: '20px' },
        handleTextClick: () => {
          // expand Footer.
          document.querySelector('#adsktm-have-question-button').click()
        },
      },
    ],
    HL07: [
      {
        isTitle: true,
        hasErrorMark: true,
        description: langStrings
          ? langStrings.requestFailedScreen.pageTitle2
          : "Request can't be completed",
        id: 'adsk-page-title',
      },
      {
        description: langStrings
          ? langStrings.hula.requestFailedScreen.exportControlBlockOREmbergoList
          : `Your eligibility to use Autodesk products is currently undergoing standard export screening which usually takes a few minutes.
          Please try again shortly. 
          For more information see the Autodesk <a href="https://www.autodesk.com/company/legal-notices-trademarks/compliance">Export Compliance policy.</a>`,
        paragraphStyle: { marginBottom: '20px' },
      },
    ],
    apigeeError: [
      {
        isTitle: true,
        hasErrorMark: true,
        description: langStrings
          ? langStrings.requestFailedScreen.pageTitle2
          : "Request can't be completed",
      },
      {
        description: langStrings
          ? langStrings.requestFailedScreen.responseText
          : 'Sorry, something went wrong while processing your request.',
        paragraphStyle: { marginBottom: '20px' },
      },
      {
        isButton: true,
        buttonTitle: langStrings
          ? langStrings.buttons.chatWithAgentButton
          : 'CHAT WITH AN AGENT',
        handleButtonClick: () =>
          window.liveagent.startChat(chatDetails.liveAgentId),
      },
    ],
  }[errorType]);

const configFooter = ({
  state: {
    langStrings,
  },
  dispatch,
}) => ({
  hasQuestion: true,
  hideBackButton: true,
  nextButtonContent: langStrings ? langStrings.buttons.restartButton : 'RESTART',
  handleNext: () => {
    dispatch({ type: 'RESTART_WIDGET' })
    window.location.reload(true);
  },
  handleExtension: () => dispatch({ type: 'TOGGLE_QUESTION_EXTENSION' }),
  handleAgentLoad: () => dispatch({ type: 'AGENT_LOADED' }),
  handleAgentAvailable: (flag) => dispatch({ type: 'AGENT_AVALIABLE', payload: { isAgentAvailable: flag } }),
  handleAgentAnalytics: () => pushGTMEvent('ChatWithAgent'),
  handleCaseAnalytics: () => pushGTMEvent('CreateCase'),
  handleNextButtonId: 'adsktm-cm-restart-button',
  handleAgentButtonId: 'adsktm-agent-button',
  handleCaseButtonId: 'adsktm-case-button',
  handleQuestionButtonId: 'adsktm-have-question-button',
  handleSupportAnalytics: () => pushGTMEvent('ContactSupport'),
});

export default {
  configContents,
  configFooter,
};
